import React, { useState } from "react";
import TablePagination from "@mui/material/TablePagination";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { makeStyles } from "@material-ui/core";
import { TableSortLabel } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  tblHead: {
    fontWeight: "bold",
    fontSize: "12px",
    color: "#4D4F5C",
  },
  tableBigScreen: {
    display: "block",
    [theme.breakpoints.down("sm")]: {
      display: "none!important",
    },
  },
}));

export default function useTable(records, filterFn, headCells) {
  const classes = useStyles();
  const pages = [10, 25, 50];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(pages[page]);
  const [order, setOrder] = useState();
  const [orderBy, setOrderBy] = useState();

  const TblHead = (props) => {
    const handleSortRequest = (cellId) => {
      const isAsc = orderBy === cellId && order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(cellId);
    };

    return (
      <TableHead className={classes.tableBigScreen}>
        <TableRow>
          {headCells.map((headCells) => (
            <TableCell
              key={headCells.id}
              className={classes.tblHead}
              sortDirection={orderBy === headCells.id ? order : false}
            >
              {" "}
              {headCells.disableSorting ? (
                headCells.label
              ) : (
                <TableSortLabel
                  active={orderBy === headCells.id}
                  direction={orderBy === headCells.id ? order : "asc"}
                  onClick={() => {
                    handleSortRequest(headCells.id);
                  }}
                >
                  {headCells.label}
                </TableSortLabel>
              )}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const TblPagination = () => (
    <TablePagination
      labelRowsPerPage={"Lignes par page:"}
      component="div"
      page={page}
      rowsPerPageOptions={pages}
      rowsPerPage={rowsPerPage}
      count={records.length}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
    />
  );

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  const recordsAfterPagingAndSorting = () => {
    return stableSort(
      filterFn.fn(records),
      getComparator(order, orderBy)
    ).slice(page * rowsPerPage, (page + 1) * rowsPerPage);
  };

  return {
    TblPagination,
    recordsAfterPagingAndSorting,
    TblHead,
  };
}
